<router-outlet></router-outlet>
<app-cookie-bar (openPolicy)="openDialog()"></app-cookie-bar>
